import { isValid } from 'clients/Clients';
import { getFeaturedProductGroups } from 'clients/ProductClientV2';
import { PRODUCT_TAG } from 'constants/Tags';
import { useEffect, useMemo, useState } from 'react';

export const useGetBlockProducts = ({ megaBlockConfigs }: { megaBlockConfigs: any }) => {
  const [blockProducts, setBlockProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const query = useMemo(() => {
    if (!megaBlockConfigs || !megaBlockConfigs.length) return undefined;

    return megaBlockConfigs.map((item: any, index: number) => ({
      index: index + 1,
      tags: item?.skuTags,
    }));
  }, [megaBlockConfigs]);

  useEffect(() => {
    if (!query) return;

    setIsLoading(true);
    getFeaturedProductGroups({
      productGroups: [
        ...query,
        {
          index: megaBlockConfigs.length + 1,
          tags: [PRODUCT_TAG.SANPHAMMOI],
        },
      ],
    })
      .then((res) => {
        if (isValid(res)) {
          const data = res.data;
          setBlockProducts(data);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [query]);

  return {
    data: blockProducts,
    isLoading,
  };
};

